export default "__VITE_ASSET__BQh2lGHA__$_?nuxt_component=async&nuxt_component_name=SvgoFuturesPause&nuxt_component_export=default__"